'use client';
import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import Link from 'next/link';
import { Routes } from '@/settings/routes';
import { App_text } from '@/settings/AppText';

export default function SpeedDial() {
    return (
        <div className="hidden fixed bottom-6 z-50 end-6 lg:block">
            <style>{`
                .speeddial-btn {
                    display: inline-flex;
                    position: relative;
                    justify-content: center;
                    align-items: center;
                    width: 56px;
                    height: 56px;
                    border-radius: 9999px;
                    border: none;
                    background: linear-gradient(135deg, #E8604C 0%, #313041 100%);
                    color: #ffffff;
                    box-shadow: 0 6px 24px rgba(232,96,76,0.45), 0 2px 8px rgba(0,0,0,0.15);
                    transition: box-shadow 0.25s ease, transform 0.25s ease;
                    cursor: pointer;
                    text-decoration: none;
                }
                .speeddial-btn:hover {
                    box-shadow: 0 10px 32px rgba(232,96,76,0.6), 0 2px 8px rgba(0,0,0,0.2);
                    transform: scale(1.12) translateY(-2px);
                }
                .speeddial-tooltip {
                    position: absolute;
                    right: 68px;
                    padding: 8px 14px;
                    font-size: 0.82rem;
                    font-weight: 600;
                    color: #ffffff;
                    white-space: nowrap;
                    border-radius: 8px;
                    background: linear-gradient(135deg, #313041 0%, #E8604C 100%);
                    box-shadow: 0 4px 14px rgba(49,48,65,0.3);
                    opacity: 0;
                    pointer-events: none;
                    transition: opacity 0.2s ease, transform 0.2s ease;
                    transform: translateX(6px);
                }
                .speeddial-btn:hover .speeddial-tooltip {
                    opacity: 1;
                    transform: translateX(0);
                }
            `}</style>

            <Link
                prefetch={false}
                href={`https://api.whatsapp.com/send?phone=${Routes.FRONT_whatsapp}`}
                target="_blank"
                aria-label={App_text.generale.spead_dial.whatsap_text}
                className="speeddial-btn"
            >
                <FaWhatsapp className="w-6 h-6" />
                <span className="speeddial-tooltip">{App_text.generale.spead_dial.whatsap_text}</span>
            </Link>
        </div>
    );
}
